/**
 * Coupon Types and Constants
 *
 * Type 0: Spend $XX Get Free Item
 * Type 1: Spend $XX Get $XX Off
 * Type 2: Buy X Get Y Free (BXGY)
 */

export const COUPON_TYPES = {
  SPEND_GET_FREE_ITEM: 0, // Spend $XX Get Free Item
  SPEND_GET_OFF: 1, // Spend $XX Get $XX Off
  BUY_X_GET_Y: 2, // Buy X Get Y Free (BXGY)
};

export const COUPON_TYPE_NAMES = {
  [COUPON_TYPES.SPEND_GET_FREE_ITEM]: 'Spend & Get Free Item',
  [COUPON_TYPES.SPEND_GET_OFF]: 'Spend & Get Discount',
  [COUPON_TYPES.BUY_X_GET_Y]: 'Buy X Get Y Free',
};

/**
 * Check if coupon is Type 0 (Spend Get Free Item)
 */
export const isSpendGetFreeItemCoupon = (coupon) =>
  coupon?.type === COUPON_TYPES.SPEND_GET_FREE_ITEM;

/**
 * Check if coupon is Type 1 (Spend Get Off)
 */
export const isSpendGetOffCoupon = (coupon) =>
  coupon?.type === COUPON_TYPES.SPEND_GET_OFF;

/**
 * Check if coupon is Type 2 (Buy X Get Y)
 */
export const isBXGYCoupon = (coupon) =>
  coupon?.type === COUPON_TYPES.BUY_X_GET_Y;

/**
 * Get coupon type name
 */
export const getCouponTypeName = (coupon) => {
  if (!coupon) return '';
  return COUPON_TYPE_NAMES[coupon.type] || 'Unknown';
};

/**
 * Get BuyItemCount from coupon (handles both camelCase variations)
 */
export const getBuyItemCount = (coupon) => {
  return coupon?.BuyItemCount || coupon?.buyItemCount || 1;
};

/**
 * Get GetItemCount from coupon (handles both camelCase variations)
 */
export const getGetItemCount = (coupon) => {
  return coupon?.GetItemCount || coupon?.getItemCount || 1;
};

/**
 * Get BXGY set size (BuyItemCount + GetItemCount)
 */
export const getBXGYSetSize = (coupon) => {
  return getBuyItemCount(coupon) + getGetItemCount(coupon);
};

/**
 * Check if item is a free item from Type 0 coupon
 */
export const isFreeItemFromCoupon = (item, coupon) => {
  if (!coupon || !isSpendGetFreeItemCoupon(coupon)) return false;
  return (
    coupon.freeitemid === item?.item?.id &&
    item?.isFreeItemFromCoupon === true
  );
};

/**
 * Check if item is a BXGY item from Type 2 coupon
 */
export const isBXGYItemFromCoupon = (item, coupon) => {
  if (!coupon || !isBXGYCoupon(coupon)) return false;
  return !!item?.bxgyInfo;
};

/**
 * Check if item has coupon benefits (free item or BXGY)
 */
export const isItemWithCouponBenefits = (item) => {
  // Free item check - must have isFreeItemFromCoupon flag
  const isFreeItem = item?.isFreeItemFromCoupon === true;

  // BXGY item check
  const isBXGYItem = !!item?.bxgyInfo;

  return isFreeItem || isBXGYItem;
};
